import React, { useEffect, useState } from 'react';
import {
  DateRangeSelector,
  Dropdown,
  DropdownItem,
  DropdownList
} from '@cokitchen/cokitchen-components';
import { ENUM_SEARCH_TYPE } from '../utils';
import { TaskHistoryFilterResult, useTaskHistoryPage } from 'hooks/useTaskHistoryPage';
import { OrdersIcon, PhoneIcon, UserIcon } from 'cokitchen-icons';

export const SEARCH_OPTIONS = [
  {
    name: 'CS or User full name',
    icon: <UserIcon />,
    id: ENUM_SEARCH_TYPE.REP_NAME
  },
  {
    name: 'Order Code',
    icon: <OrdersIcon />,
    id: ENUM_SEARCH_TYPE.ORDER_CODE
  },

  {
    name: 'Task',
    icon: <PhoneIcon />,
    id: ENUM_SEARCH_TYPE.TASK
  }
];

type Props = {
  searchVal: string;
  setSearchVal: (data: string) => void;
  setSelectedSearchReturnVal: (data: TaskHistoryFilterResult & { type?: ENUM_SEARCH_TYPE }) => void;
  filters: { date: { startDate: Date; endDate: Date } };
  setFilters: (val: { date: { startDate: Date; endDate: Date } }) => void;
};
const TaskHistoryFilter = ({
  setSearchVal: setSearchValForTask,
  searchVal: searchValForTask,
  setSelectedSearchReturnVal,
  filters,
  setFilters
}: Props) => {
  const [selectedSearchType, setSelectedSearchType] = useState(SEARCH_OPTIONS[0]);
  const [searchVal, setSearchVal] = useState('');
  const [showResults, setShowResults] = useState(false);

  const { orderUserDatas, loadingSearch } = useTaskHistoryPage({
    searchVal: searchVal,
    filterType: selectedSearchType.id
  });

  useEffect(() => {
    if (searchVal.length === 0) setSelectedSearchReturnVal({ id: '', name: '' });
  }, [searchVal]);

  return (
    <ul className='flex gap-6 items-center '>
      <li className='flex gap-1 items-center'>
        <span className='text-sm text-gray-8'>Filter by:</span>
        <div className='border border-gray-border flex items-center p-1.5 rounded-md'>
          <Dropdown
            content={
              <div className='text-gray-8 bg-gray-border cursor-pointer rounded-lg p-1.5'>
                {selectedSearchType.icon}
              </div>
            }>
            <DropdownList>
              {SEARCH_OPTIONS.map((detail) => (
                <DropdownItem
                  onClick={() => {
                    setSelectedSearchType(detail);
                    setSearchVal('');
                    setSearchValForTask('');
                  }}
                  buttonClassName={`gap-2 py-2 ${
                    selectedSearchType.id === detail.id ? 'bg-[#fafafa]' : ''
                  }`}
                  key={`${detail.id}-${detail.name}`}>
                  <span className='text-gray-8'>{detail.icon}</span>
                  {detail.name}
                </DropdownItem>
              ))}
            </DropdownList>
          </Dropdown>
          <Dropdown
            visible={showResults}
            content={
              <input
                value={
                  selectedSearchType.id === ENUM_SEARCH_TYPE.TASK ? searchValForTask : searchVal
                }
                onChange={(e) => {
                  setShowResults(true);
                  selectedSearchType.id === ENUM_SEARCH_TYPE.TASK
                    ? setSearchValForTask(e.target.value)
                    : setSearchVal(e.target.value);
                }}
                onBlur={() =>
                  setTimeout(() => {
                    setShowResults(false);
                  }, 1500)
                }
                onFocus={() => setShowResults(true)}
                placeholder={`Search ${selectedSearchType.id.replaceAll('_', ' ')}`}
                className='bg-transparent placeholder:text-sm pl-1 focus:outline-none'
              />
            }>
            <DropdownList>
              {loadingSearch ? (
                <DropdownItem isLabel>Loading ...</DropdownItem>
              ) : orderUserDatas.length === 0 ? (
                <DropdownItem isLabel>No match available</DropdownItem>
              ) : (
                orderUserDatas.map((detail) => (
                  <DropdownItem
                    onClick={() => {
                      setShowResults(false);
                      setSelectedSearchReturnVal({ ...detail, type: selectedSearchType.id });
                    }}
                    buttonClassName='gap-2 py-2'
                    key={`${detail.id}-${detail.name}`}>
                    {detail.name}
                  </DropdownItem>
                ))
              )}
            </DropdownList>
          </Dropdown>
          {/* <input
            list='data-options'
            value={selectedSearchType.id === ENUM_SEARCH_TYPE.TASK ? searchValForTask : searchVal}
            onChange={(e) =>
              selectedSearchType.id === ENUM_SEARCH_TYPE.TASK
                ? setSearchValForTask(e.target.value)
                : setSearchVal(e.target.value)
            }
            placeholder={`Search ${selectedSearchType.id.replaceAll('_', ' ')}`}
            className='bg-transparent placeholder:text-sm pl-1 focus:outline-none'
          />
          <datalist id='data-options'>
            {orderUserDatas.map((detail) => (
              <option value={detail.id} key={`${detail.id}-${detail.name}`}>
                {detail.name}
              </option>
            ))}
          </datalist> */}
        </div>
      </li>
      <li className='flex gap-3 items-center'>
        <DateRangeSelector showTime onChange={(v) => setFilters({ ...filters, date: v.date })} />
      </li>
    </ul>
  );
};

export default TaskHistoryFilter;
